/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Divider, Drawer, List, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'src/hooks';
import { modules } from '../../modules.js';
import NavItem from './NavItem';
import { Creators as UserCreators } from 'src/store/ducks/user';
import { useNotification } from 'src/context/notification-context.js';
import { getScreenSize } from 'src/utils/getUtils.js';
import FlatIcon, { FlatIconOptions } from 'src/components/ui/FlatIcon/index.js';

const useStyles = makeStyles((theme) => ({
  mobileSidebar: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
    },
  },
  desktopSidebar: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  logoutMobileButton: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
  logoutButton: {
    marginTop: 'auto',
    fontWeight: 'medium',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    textTransform: 'none',
    width: '100%',
    height: '48px',
    '& svg': {
      marginRight: '8px',
    },
  },
  newsButton: {
    display: 'none',
    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },
}));

const MAX_TOPICS_STORED = 10;

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const [menu, setMenu] = useState([]);
  const [subitemsVisible, setSubitemsVisible] = useState('');
  const [selectedSubItem, setSelectedSubItem] = useState('');
  const [subSubitemsVisible, setSubSubitemsVisible] = useState('');
  const [selectedSubSubItem, setSelectedSubSubItem] = useState('');
  const { notificationRef, notifications, appBarSize } = useNotification();
  const location = useLocation();

  const { signOut, user } = useAuth();
  const classes = useStyles();

  const [pulse, setPulse] = useState(false);
  const [currentNews, setCurrentNews] = useState(null);

  const [notificationHeight, setNotificationHeight] = useState(0);

  useEffect(() => {
    const updateNotificationHeight = () => {
      setNotificationHeight(notificationRef?.current?.offsetHeight ?? 0);
    };

    updateNotificationHeight();

    window.addEventListener('resize', updateNotificationHeight);
    return () => window.removeEventListener('resize', updateNotificationHeight);
  }, [notificationRef]);

  useEffect(() => {
    setNotificationHeight(notificationRef?.current?.offsetHeight ?? 0);
  }, [notifications]);

  function verificaPermissoes() {
    setMenu([
      {
        id: modules.home.id,
        href: modules.home.path,
        icon: FlatIconOptions.dashboard,
        title: modules.home.title,
        disabled: false,
        subitems: [],
        order: 1,
      },
      {
        id: modules.quickSearch.id,
        href: modules.quickSearch.path,
        icon: FlatIconOptions.search,
        title: modules.quickSearch.title,
        disabled: false,
        subitems: [],
        order: 2,
      },
      {
        id: 2,
        href: '#',
        icon: FlatIconOptions.layers,
        title: 'Cadastros',
        disabled: false,
        subitems: [
          {
            id: modules.storage.id,
            href: modules.storage.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.storage.title,
            disabled: false,
          },
          {
            id: modules.stockAddress.id,
            href: modules.stockAddress.href || modules.stockAddress.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.stockAddress.title,
            disabled: false,
            newer: true,
          },
          {
            id: modules.pickingBox.id,
            href: modules.pickingBox.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.pickingBox.title,
            disabled: false,
          },
          {
            id: modules.packaging.id,
            href: modules.packaging.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.packaging.title,
            disabled: false,
          },
        ],
        order: 3,
      },
      {
        id: modules.productsListing.id,
        href: '#',
        icon: FlatIconOptions.product,
        title: modules.productsListing.title,
        disabled: false,
        subitems: [
          {
            id: modules.productsListing.id,
            href: modules.productsListing.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.manageProducts.title,
            description: modules.manageProducts.title,
            disabled: false,
          },
        ],
        order: 4,
      },
      {
        id: 7,
        href: '#',
        icon: FlatIconOptions.sales,
        title: 'Vendas',
        disabled: false,
        subitems: [
          {
            id: modules.sales.id,
            href: modules.sales.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.sales.title,
            disabled: false,
          },
        ],
        order: 5,
      },
      {
        id: 3,
        href: '#',
        icon: FlatIconOptions.stock,
        title: 'Estoque',
        disabled: false,
        subitems: [
          {
            id: modules.stockAllocation.id,
            href: modules.stockAllocation.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.stockAllocation.title,
            disabled: false,
          },
          {
            id: modules.inventoryMovement.id,
            href: modules.inventoryMovement.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.inventoryMovement.title,
            disabled: false,
          },
          {
            id: modules.reSupplies.id,
            href: modules.reSupplies.path,
            icon: FlatIconOptions.resupplies,
            title: modules.reSupplies.title,
            disabled: false,
            newer: true,
            subitems: [
              {
                id: modules.movementByNecessity.id,
                href: modules.movementByNecessity.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.reSupplies.title,
                description: modules.movementByNecessity.title,
                disabled: false,
              },
            ],
          },
          {
            id: modules.inventory.id,
            href: modules.inventory.path,
            icon: FlatIconOptions.inventory,
            title: modules.inventory.title,
            disabled: false,
            newer: false,
            subitems: [
              {
                id: modules.inventoryRequests.id,
                href: modules.inventoryRequests.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.inventory.title,
                description: modules.inventoryRequests.title,
                disabled: false,
              },
              {
                id: modules.createInventory.id,
                href: modules.createInventory.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.inventory.title,
                description: modules.createInventory.title,
                disabled: false,
              },
              {
                id: modules.takeInventory.id,
                href: modules.takeInventory.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.inventory.title,
                description: modules.takeInventory.title,
                disabled: false,
              },

              {
                id: modules.reportStockDivergence.id,
                href: modules.reportStockDivergence.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.inventory.title,
                description: modules.reportStockDivergence.title,
                disabled: false,
              },
            ],
          },
          {
            id: modules.stockTransfer.id,
            href: '#',
            icon: FlatIconOptions.stockTransfer,
            title: modules.stockTransfer.title,
            disabled: false,
            subitems: [
              {
                id: modules.stockRequestTransfer.id,
                href: modules.stockRequestTransfer.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.stockTransfer.title,
                description: modules.stockRequestTransfer.title,
                disabled: false,
              },
              {
                id: modules.takeTransfer.id,
                href: modules.takeTransfer.path,
                icon: FlatIconOptions.menuSubItem,
                title: modules.stockTransfer.title,
                description: modules.takeTransfer.title,
                disabled: false,
              },
            ],
          },
        ],
        order: 6,
      },
      {
        id: 4,
        href: '#',
        icon: FlatIconOptions.shipping,
        title: 'Expedição',
        disabled: false,
        subitems: [
          {
            id: modules.picking.id,
            href: modules.picking.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.picking.title,
            disabled: false,
          },
          {
            id: modules.packingBox.id,
            href: modules.packingBox.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.packingBox.title,
            disabled: false,
          },
        ],
        order: 7,
      },
      {
        id: 5,
        href: '#',
        icon: FlatIconOptions.reports,
        title: 'Relatórios',
        disabled: false,
        subitems: [
          {
            id: modules.userActions.id,
            href: modules.userActions.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.userActions.title,
            disabled: false,
          },
        ],
        order: 8,
      },
      {
        id: 6,
        href: '#',
        icon: FlatIconOptions.system,
        title: 'Sistema',
        disabled: false,
        subitems: [
          {
            id: modules.userControl.id,
            href: modules.userControl.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.userControl.title,
            disabled: false,
          },
          {
            id: modules.pickingPriority.id,
            href: modules.pickingPriority.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.pickingPriority.title,
            disabled: false,
          },
        ],
        order: 9,
      },
      {
        id: 8,
        href: '#',
        icon: FlatIconOptions.receiving,
        title: 'Recebimentos',
        disabled: false,
        mirrorTheIcon: true,
        beta: true,
        subitems: [
          // {
          //   id: modules.receivingInformNfe.id,
          //   href: modules.receivingInformNfe.path,
          //   icon: FlatIconOptions.menuSubItem,
          //   title: modules.receivingInformNfe.title,
          //   description: modules.receivingInformNfe.title,
          //   disabled: false,
          // },

          // {
          //   id: modules.receivingSchedulingConfig.id,
          //   href: modules.receivingSchedulingConfig.path,
          //   icon: FlatIconOptions.menuSubItem,
          //   title: modules.receivingSchedulingConfig.title,
          //   description: modules.receivingSchedulingConfig.title,
          //   disabled: false,
          // },
          {
            id: modules.receivingDashboard.id,
            href: modules.receivingDashboard.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingDashboard.title,
            description: modules.receivingDashboard.title,
            disabled: false,
          },
          {
            id: modules.receivingApproveScheduling.id,
            href: modules.receivingApproveScheduling.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingApproveScheduling.title,
            description: modules.receivingApproveScheduling.title,
            disabled: false,
          },

          {
            id: modules.receivingSchedule.id,
            href: modules.receivingSchedule.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingSchedule.title,
            description: modules.receivingSchedule.title,
            disabled: false,
          },
          {
            id: modules.receivingConference.id,
            href: modules.receivingConference.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingConference.title,
            description: modules.receivingConference.title,
            disabled: false,
          },
          {
            id: modules.receivingReceive.id,
            href: modules.receivingReceive.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingReceive.title,
            description: modules.receivingReceive.title,
            disabled: false,
          },

          {
            id: modules.receivingProductsConference.id,
            href: modules.receivingProductsConference.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.receivingProductsConference.title,
            description: modules.receivingProductsConference.title,
            disabled: true,
            comingSoon: true,
          },
          {
            id: modules.reportReceivingDivergence.id,
            href: modules.reportReceivingDivergence.path,
            icon: FlatIconOptions.menuSubItem,
            title: modules.reportReceivingDivergence.title,
            disabled: true,
            beta: false,
            comingSoon: true,
          },
        ],
        order: 5,
      },
    ]);
  }

  useEffect(() => {
    verificaPermissoes();
  }, [user]);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  useEffect(() => {
    const checkNewsStatus = () => {
      const newsUrl = process.env.REACT_APP_NEWS_URL ?? '';
      setCurrentNews(newsUrl);

      try {
        const stored = window.localStorage.getItem('news_versions');
        const topics = stored ? JSON.parse(stored) : [];

        const lastVersionChecked = window.localStorage.getItem('user_last_checked_version') || 'false';
        const isNewVersion = !topics.includes(newsUrl);

        setPulse(isNewVersion || lastVersionChecked === 'false');
      } catch (error) {
        setPulse(false);
      }
    };

    checkNewsStatus();
  }, []);

  const openWMSNews = () => {
    if (!currentNews) return;

    try {
      const stored = window.localStorage.getItem('news_versions');
      let topics = stored ? JSON.parse(stored) : [];

      const lastVersionChecked = window.localStorage.getItem('user_last_checked_version') || 'false';

      if (lastVersionChecked === 'false') {
        window.localStorage.setItem('user_last_checked_version', 'true');
      }

      if (!topics.includes(currentNews)) {
        topics.push(currentNews);

        if (topics.length > MAX_TOPICS_STORED) {
          topics = topics.slice(-MAX_TOPICS_STORED);
        }

        window.localStorage.setItem('news_versions', JSON.stringify(topics));
        UserCreators.getUserLastCheckedVersion();
      }

      setPulse(false);

      window.open(currentNews, '_blank');
    } catch (error) {
      window.open(currentNews, '_blank');
    }
  };

  const content = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        py={1}>
        {window.localStorage.getItem('companyName') && (
          <Typography
            color='textPrimary'
            variant='subtitle1'
            sx={{
              fontWeight: 600,
              maxWidth: '200px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'center',
            }}>
            {window.localStorage.getItem('companyName')}
          </Typography>
        )}
        <Typography
          color='textPrimary'
          variant='h5'>
          {user?.name}
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}>
        <Box>
          <List>
            {menu
              .sort((a, b) => a.order - b.order)
              .map((item) => (
                <NavItem
                  disabled={item.disabled}
                  subitems={item.subitems}
                  href={item.href}
                  key={item.title}
                  title={item.title}
                  icon={item.icon}
                  setSubitemsVisible={setSubitemsVisible}
                  subitemsVisible={subitemsVisible}
                  setSelectedSubItem={setSelectedSubItem}
                  selectedSubItem={selectedSubItem}
                  setSubSubitemsVisible={setSubSubitemsVisible}
                  subSubitemsVisible={subSubitemsVisible}
                  setSelectedSubSubItem={setSelectedSubSubItem}
                  selectedSubSubItem={selectedSubSubItem}
                  mirrorTheIcon={item.mirrorTheIcon}
                  beta={item.beta ?? false}
                  newer={item.newer ?? false}
                />
              ))}
          </List>
          <Box className={classes.logoutMobileButton}>
            <Button
              className={classes.logoutButton}
              onClick={signOut}>
              <FlatIcon icon={FlatIconOptions.exit} /> Sair
            </Button>
          </Box>
        </Box>
        <Box className={classes.newsButton}>
          <Button
            className={classes.logoutButton}
            onClick={openWMSNews}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
              }}>
              <FlatIcon
                icon={FlatIconOptions.news}
                sx={{ zIndex: 999 }}
              />
              {pulse && (
                <Box
                  sx={{
                    position: 'absolute',
                    border: '1px solid transparent',
                    borderRadius: '50%',
                    marginRight: '10px',
                    animation: 'pulseBorder 1.5s infinite ease-in-out',
                    '@keyframes pulseBorder': {
                      '0%': {
                        padding: 0,
                        borderWidth: '0px',
                        borderColor: 'rgba(255, 0, 0, 1)',
                      },
                      '100%': {
                        padding: 2,
                        borderWidth: '7px',
                        borderColor: 'rgba(255, 0, 0, 0)',
                      },
                    },
                  }}
                />
              )}
            </Box>
            Novidades
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box zIndex={1}>
      {!window.location.href.includes('separacao_') && (
        <Box className={classes.desktopSidebar}>
          <Drawer
            anchor='left'
            onClose={onMobileClose}
            open={openMobile}
            variant='temporary'
            PaperProps={{
              style: {
                width: 256,
                top: notificationHeight + appBarSize,
                height: getScreenSize().height - (notificationHeight + appBarSize),
                transition: 'top 0.3s ease',
                overflowX: 'hidden',
                zIndex: 2,
              },
            }}>
            {content}
          </Drawer>
        </Box>
      )}
      <Box className={classes.mobileSidebar}>
        <Drawer
          anchor='left'
          open
          variant='persistent'
          PaperProps={{
            style: {
              width: 256,
              top: notificationHeight + appBarSize,
              height: getScreenSize().height - (notificationHeight + appBarSize),
              transition: 'top 0.3s ease',
              overflow: 'hidden',
              zIndex: 2,
            },
          }}>
          {content}
        </Drawer>
      </Box>
    </Box>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default DashboardSidebar;
